import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { BILLING_CHARGE_BASE_PATH } from '../../../../../features/billing/charge/billing-charge-routing';

export const Route = createFileRoute('/_app/_clearing-core/billing/charge/_charge')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'billing-charge-list',
        label: 'Billing',
        to: BILLING_CHARGE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
